export default __webpack_public_path__ + "static/media/1617.bca6f981.png";